import React, { useEffect, useRef } from 'react';
import { useEvents } from '../../hooks/useEvents';
import { getEnvironmentVariable } from '../../utils';

type UnauthorizedBoundaryProps = {
    children: React.ReactNode;
};

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');

export const redirectToLogin = () => {
    if (!platformURL) {
        console.error('REACT_APP_PLATFORM_URL is not configured.');
        return;
    }

    localStorage.removeItem('SHOULD_NOT_AUTH');

    const normalizedPlatformURL = platformURL.replace(/\/+$/, '');
    const loginURL = new URL(`${normalizedPlatformURL}/login`);

    loginURL.searchParams.set(
        'callback',
        window.location.href,
    );

    window.location.replace(loginURL.toString());
};

const UnauthorizedBoundary: React.FC<UnauthorizedBoundaryProps> = ({
    children,
}) => {
    const { subscribe } = useEvents();
    const redirectStartedRef = useRef(false);

    useEffect(() => {
        return subscribe('http-401', (data) => {
            const statusCode = Number(
                data?.code ||
                data?.status ||
                data?.response?.status,
            );

            if (statusCode !== 401) {
                return;
            }

            if (redirectStartedRef.current) {
                return;
            }

            redirectStartedRef.current = true;
            redirectToLogin();
        });
    }, [ subscribe ]);

    return <>{children}</>;
};

export default UnauthorizedBoundary;